/**
 * @generated SignedSource<<43b879b5f2ae4e5c9e1ffab96a0253af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveContactAttributeInput = {
  attributeName: string;
  id: string;
};
export type ContactAttributesPanelRemoveContactAttributeMutation$variables = {
  input: RemoveContactAttributeInput;
};
export type ContactAttributesPanelRemoveContactAttributeMutation$data = {
  readonly removeContactAttribute: {
    readonly attributes: ReadonlyArray<{
      readonly name: string;
      readonly value: string;
    }>;
    readonly id: string;
  };
};
export type ContactAttributesPanelRemoveContactAttributeMutation = {
  response: ContactAttributesPanelRemoveContactAttributeMutation$data;
  variables: ContactAttributesPanelRemoveContactAttributeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ContactAttribute",
  "kind": "LinkedField",
  "name": "attributes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactAttributesPanelRemoveContactAttributeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeContactAttribute",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactAttributesPanelRemoveContactAttributeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeContactAttribute",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c75334c86d3e365598fa73793cadff63",
    "id": null,
    "metadata": {},
    "name": "ContactAttributesPanelRemoveContactAttributeMutation",
    "operationKind": "mutation",
    "text": "mutation ContactAttributesPanelRemoveContactAttributeMutation(\n  $input: RemoveContactAttributeInput!\n) {\n  removeContactAttribute(input: $input) {\n    __typename\n    id\n    attributes {\n      name\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5405cd47df6748d400678bb7b3b63c74";

export default node;
